/**
 * To convert the path array to a string for the listener keys
 * Use a crazy separator. If the separator was a '.', and the user had a prop with a dot in it,
 * then it could cause false matches in the updated logic.
 */
var PROP_PATH_SEP = '~~~';
var PATH = Symbol('PATH');
var ORIGINAL = Symbol('ORIGINAL');
var LS_KEYS = {
  RR_HISTORY_LIMIT: 'RR_HISTORY_LIMIT',
  RR_DEBUG: 'RR_DEBUG'
};
export { LS_KEYS, ORIGINAL, PATH, PROP_PATH_SEP };